<template>
  <div>
    <app-home-request
      v-for="index in homeRequest.length"
      :key="index"
      :index="index - 1"
      :homeRequest="homeRequest[index - 1]"
      :showedit="false"
    >
    </app-home-request>
  </div>
</template>

<script>
import Vue from "vue";
import Item from "./Item";

export default {
  created() {
    this.$store.dispatch("getHistory");
  },
  components: {
    appHomeRequest: Item,
  },
  computed: {
    homeRequest() {
      return this.$store.getters.homeRequestHistory;
    },
  },
};
</script>
<style scoped>
</style>
